import DialogContent from '@material-ui/core/DialogContent'
import Typography from '@material-ui/core/Typography'
import Dialog from 'lib/ui/Dialog'
import {colors} from 'lib/ui/theme'
import Box from '@material-ui/core/Box'
import React from 'react'
import {withStyles} from '@material-ui/core/styles'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import {TimesCircle} from 'lib/ui/Icon'
import styled from 'styled-components'

export default function ErrorDialog(props: {
  showing: boolean
  onClose: () => void
  children: string | string[]
}) {
  return (
    <Dialog open={props.showing} onClose={props.onClose}>
      <DialogContent dividers>
        <MessageBox>
          <Typography align="center" variant="h5">
            {props.children}
          </Typography>
        </MessageBox>
        <Box textAlign="center">
          <TimesCircle color={colors.error} iconSize={38} />
        </Box>
      </DialogContent>
      <CenteredActions>
        <Button onClick={props.onClose} color="primary" aria-label="close">
          Close
        </Button>
      </CenteredActions>
    </Dialog>
  )
}

const MessageBox = styled(Box)`
  padding: 32px 72px;

  @media (max-width: ${(props) => props.theme.breakpoints.sm}) {
    && {
      padding: 32px 0;
    }
  }
`

const CenteredActions = withStyles({
  root: {
    justifyContent: 'center',
  },
})(DialogActions)
